function Field({ label, hint, error, required, badge, children, htmlFor, className = '' }) {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <div className="flex items-center justify-between gap-3">
        <label
          htmlFor={htmlFor}
          className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.18em] text-white/55"
        >
          <span>{label}</span>
          {required && (
            <span aria-hidden="true" className="text-violet-300/90">
              *
            </span>
          )}
        </label>
        {badge}
      </div>
      {children}
      <div className="flex items-center justify-between min-h-[16px]">
        {error ? (
          <p
            role="alert"
            className="text-xs font-medium text-rose-300/90 animate-fade-up"
          >
            {error}
          </p>
        ) : hint ? (
          <p className="text-xs text-white/40">{hint}</p>
        ) : (
          <span />
        )}
      </div>
    </div>
  );
}

export default Field;